import {Renderer2} from "@angular/core";
import {DropdownFilterType} from "../interfaces/dropdown-filter-type";
import {MainHelper} from "../../shared/models/main-helper";
import {OnDropdownFilteredEventArgs} from "./on-dropdown-filtered-event-args";
import {EventArgs} from "./event-args";
import {CustomFunctionReturn} from "./custom-function-return";
import * as moment from 'moment';
import {SlickFilterItem} from "./slick-filter-item";

export class SlickGridFilterHelper {
    constructor(
    ) {
        this.helper = new MainHelper();
        this.filters = [];
    }

    private helper: MainHelper;
    public filters: OnDropdownFilteredEventArgs<any>[];

    //# render elements foe number-filter
    public readonly renderSelect = (renderer: Renderer2, select: HTMLElement, translates: any): void => {
        let equel = renderer.createElement('option'),
            notEquel = renderer.createElement('option'),
            less  = renderer.createElement('option'),
            lessEqual  = renderer.createElement('option'),
            moreEquel = renderer.createElement('option'),
            more = renderer.createElement('option'),
            between = renderer.createElement('option');

        renderer.setAttribute(equel, 'value', '1');
        renderer.setAttribute(equel, 'selected', '');
        renderer.setAttribute(notEquel, 'value', '2');
        renderer.setAttribute(less, 'value', '3');
        renderer.setAttribute(lessEqual, 'value', '4');
        renderer.setAttribute(moreEquel, 'value', '5');
        renderer.setAttribute(more, 'value', '6');
        renderer.setAttribute(between, 'value', '7');

        renderer.appendChild(equel, renderer.createText('='));
        renderer.appendChild(notEquel, renderer.createText('≠'));
        renderer.appendChild(less, renderer.createText('<'));
        renderer.appendChild(lessEqual, renderer.createText('≤'));
        renderer.appendChild(moreEquel, renderer.createText('≥'));
        renderer.appendChild(more, renderer.createText('>'));
        renderer.appendChild(between, renderer.createText(translates.Between));

        renderer.appendChild(select, equel);
        renderer.appendChild(select, notEquel);
        renderer.appendChild(select, less);
        renderer.appendChild(select, lessEqual);
        renderer.appendChild(select, moreEquel);
        renderer.appendChild(select, more);
        renderer.appendChild(select, between);
    }

    //# add or remove filters from grid
    public onGridFiltered = (args: EventArgs<OnDropdownFilteredEventArgs<any>>): void =>{
        const idx = this.filters.findIndex(f => f.column.field === args.data.column.field);
        // console.log(idx, args, 'onGridFiltered')
        if (idx >= 0){
            this.filters.splice(idx, 1);
        }

        if (args.data.filterType === 'dropdown' && !args.data.value.length ||
            args.data.filterType === 'input' && !args.data.value.length ||
            args.data.filterType === 'input-number' && args.data.value[0] === null && args.data.value[1] === null
        ){
            if (idx < 0){
                return;
            }
        } else{
            // console.log(args.data, 'onGridFiltered 2')
            this.filters.push(args.data);
        }
    };

    //# filtration method, with posibillity add custom methods to  foe filtrating
    public filter = (item: any): boolean => {
        // console.log(item, 'filter start')
        const startFilter: CustomFunctionReturn = this.startFilter ? this.startFilter(item) : null;

        if (startFilter && startFilter.ret){
            return startFilter.res;
        }

        for (const filter of this.filters) {
            const value = item[filter.column.field];
            // console.log(filter, item, 'filter 3')
            let result: boolean;
            if (['dropdown', 'input'].includes(filter.filterType)){
                switch (filter.type) {
                    case DropdownFilterType.Blank:
                        result = value == null || value === '';
                        break;
                    case DropdownFilterType.NonBlank:
                        result = value != null && value !== '';
                        break;
                    case DropdownFilterType.ByValue:
                        result = filter.filterType === 'dropdown' ? this.filterByValue(value, filter.value) : this.filterBySearchValue(value, filter.value);
                        break;
                    default:
                        result = true;
                }
            } else if (filter.filterType === 'input-number') {
                result = filter.type === DropdownFilterType.ByValue ? this.filterByNumber(value, filter.value, filter.numberFilterType) : true;
            } else if (filter.filterType === 'date-range'){

            }

            if (result){
                continue;
            }

            const endLoopFilterChange: CustomFunctionReturn = this.endLoopFilterChange ? this.endLoopFilterChange(item) : null;

            if (endLoopFilterChange && endLoopFilterChange.ret){
                return endLoopFilterChange.res;
            }

            if (!result){
                return false;
            }
        }

        const endFilterChange: CustomFunctionReturn = this.endFilterChange ? this.endFilterChange(item) : null;

        if (endFilterChange && endFilterChange.ret){
            return endFilterChange.res;
        }

        return true;
    };

    public startFilter: (row: any) => CustomFunctionReturn;

    public endLoopFilterChange: (row: any) => CustomFunctionReturn;

    public endFilterChange: (row: any) => CustomFunctionReturn;

    //# check if data equal in sell filtrating
    private filterByValue = (filterVal: any, data: SlickFilterItem[]): boolean => {
        // console.log((typeof filterVal), filterVal, data, 'filterByValue')
        return data.some(item => moment.isMoment(item.value) ? moment(item.value).isSame(filterVal) : item.value === filterVal);
    };

    //# check if data equal in sell filtrating
    private filterBySearchValue = (filterVal: any, data: SlickFilterItem[]): boolean => {
        // console.log(filterVal, data, 'filterBySearchValue')
        if (typeof filterVal === 'string') {
            return data.some(item => moment.isMoment(item.value) ? moment(item.value).isSame(filterVal) : item.value === filterVal);
            // return this.helper.matchText(data, filterVal, false);
        } else {
            return data.some(item => {
                let itemNumber = Number(item.value);
                return itemNumber || itemNumber === 0 ? itemNumber === filterVal : false;
            });
        }
    };

    //# return result by filter number
    private filterByNumber = (filterVal: any, data: any, type: number): boolean => {
        if (typeof filterVal === 'string'){
            filterVal = this.helper.customParseNumber(filterVal);
        }
        switch (type){
            case 1: return filterVal === data[0];
            case 2: return filterVal !== data[0];
            case 3: return filterVal < data[0];
            case 4: return filterVal <= data[0];
            case 5: return filterVal >= data[0];
            case 6: return filterVal > data[0];
            case 7: return filterVal >= data[0] && filterVal <= data[1];
        }
    };

    //# return result by filter range date
    private filterByDateRange = (data: any, filterVal: {start: Date, end: Date}): boolean => {
        if (moment.isMoment(data)){
            return  data.isBetween(filterVal.start, filterVal.end, null, '[]')
        } else {
            let check = new Date(data);
            return check > filterVal.start && check < filterVal.end
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/slick-grid-filter-helper.ts